import React, { useState, useContext, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ReactDOM from 'react-dom'
import ModalWindow from '../../layout/modalwindow/ModalWindow';
import StockOutFooterStyle from './css/StockOutFooterStyle'
import { ContentFooter } from '../../layout/Content'
import StockOutListController from '../stockoutlist/StockOutListController'
import StockOutItemController from '../stockoutitem/StockOutItemController'
import { stockOutControllerContext } from './StockOutController'
import { appContext } from '../../../App'
import { getStockOutByID } from '../StockOutFunctions'
import { longDateAndTimeString } from '../../utilities/utilities'

function StockOutFooter() {
  const app = useContext(appContext)
  const setContent = app.content[1]
  const stockOutController = useContext(stockOutControllerContext)
  const stockOut = stockOutController.stockOut[0]
  const { saveStockOut, refStockOut } = stockOutController
  const [newRecordCount, setNewRecordCount] = useState(0)
  const [successMessage, setSuccessMessage] = useState(false)
  const [postOK, setPostOK] = useState(null)

  const showMessageBoxSONotFound = () => {
    const onClick = () => {
      ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
      setContent(<StockOutListController />)
    }

    ReactDOM.render (
      <ModalWindow
        id='mw-parent'
        width='25'
        height='20'
        header='SO Not Found'
        footer={null}>
        <div className='messagebox'>
          <div className='messagebox-content'>
            <div>The StockOut file/record no longer exist.</div>
          </div>
          <div className='button-container'>
            <button onClick={onClick} className='pospro-action-btn top-anchor'>Ok</button>
          </div>
        </div>
      </ModalWindow>,
      document.getElementById('modal-form-container')
    )
  }

  const onClickPost = async () => {
    const stock_out = await getStockOutByID(app, stockOut._id)

    const showMessageBoxSOAlreadyPosted = () => {
      const last_modified_by = stock_out.log.last_modified_by.name
      const last_modified = longDateAndTimeString(new Date(stock_out.date_time_modified))
      const onClick = () => {
        setContent(<StockOutListController />)
        ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
      }

      ReactDOM.render (
        <ModalWindow
          id='mw-parent'
          height='25'
          width='30'
          header='SO Posted'
          footer={null}>
          <div className='messagebox'>
            <div className='messagebox-content'>
              <div>This StockOut is already Posted</div>
              <br />
              <div>Posted by {last_modified_by} on {last_modified}</div>
            </div>
            <div className='button-container'>
              <button onClick={onClick} className='pospro-action-btn bottom-anchor'>Ok</button>
            </div>
          </div>
        </ModalWindow>,
        document.getElementById('modal-form-container')
      )
    }

    const showMessageBox = () => {
      const onClick = async (button) => {
        if (button === 'Yes') {
          stock_out.status = 'Posted'
          saveStockOut(app, stock_out)
          .then(so => {
            if (so) {
              refStockOut.current = stock_out
              setSuccessMessage('Posted successfully! Loading Stockout Item, Please wait...')
              setNewRecordCount(newRecordCount + 1)
              setTimeout(() => {
                setSuccessMessage('')
                setContent(<StockOutItemController stockOutItem={so}/>)
              }, 1000)
            } else {
              setSuccessMessage('Something went wrong. Post failed! Loading StockOut List, please wait...')
              setTimeout(() => {
                setSuccessMessage('')
                setContent(<StockOutListController />)
              }, 1000)
            }
          })
        }

        ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
      }

      ReactDOM.render (
        <ModalWindow
          id='mw-parent'
          header='Posted'
          footer={null}>
          <div className='messagebox'>
            <div className='messagebox-content'>
              <div>You are about to remove these products to your inventory.</div>
              <br/>
              <div>Are you sure you want to continue?</div>
            </div>
            <div className='button-container'>
              <button onClick={() => { onClick('No') }} className='pospro-action-btn top-anchor'>No</button>
              <button onClick={() => { onClick('Yes') }} className='pospro-action-btn bottom-anchor'>Yes</button>
            </div>
          </div>
        </ModalWindow>,
        document.getElementById('modal-form-container')
      )
    }

    if (stock_out) {
      if (stock_out.status !== 'Posted') showMessageBox()
      else showMessageBoxSOAlreadyPosted()
    } else showMessageBoxSONotFound()
  }

  const onClickTransactionsList = async () => setContent(<StockOutListController />)

  useEffect(() => {
    setPostOK(
      stockOut.date_released &&
      stockOut.prepared_by &&
      (stockOut.item_details.length > 0)
    )
  }, [stockOut])

  return (
    <ContentFooter>
        <div id="messagebox-container"></div>
        <div id="stock-out-footer-container">
          <span id='new-record-count-container'>
            <span style={{visibility: newRecordCount ? 'visible' : 'hidden'}} id='new-record-count'>
              { newRecordCount ?
                  `${newRecordCount} new record(s) added`
                : null
              }
            </span>
            <span style={{visibility: successMessage ? 'visible' : 'hidden'}} className='notification'>{successMessage}</span>
          </span>
          <div className='translist-button-container'>
            <button className="pospro-action-btn"
              id="trans-list-btn"
              type="button"
              onClick={onClickTransactionsList}>
              <FontAwesomeIcon icon='list-alt'/>&nbsp;Transactions List
            </button>
            <button className={ !postOK ? 'pospro-action-btn disabled-button' : 'pospro-action-btn' }
              id="post-item-btn"
              type="button"
              disabled={!postOK}
              onClick={onClickPost}>
              <FontAwesomeIcon icon='save'/>&nbsp;Post
            </button>
          </div>
        </div>
        <StockOutFooterStyle />
    </ContentFooter>
  )
}

export default React.memo(StockOutFooter)